import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const InspectorReferenceRecord = Record({
  id: null,
  key: null,
  label: null,
  types: List(),
  inverseTypes: List(),
  icon: null,
  bidirectional: false,
  inverseLabel: null,
  showInverse: false,
  showInInspector: false
});

const data = {
  objects: {
    types: "List",
    inverseTypes: "List"
  }
};
createFromJS.registerCallback(
  "InspectorReferenceRecord",
  createFromJS.createNestedCallback(InspectorReferenceRecord, data)
);
